// extracted by mini-css-extract-plugin
export default {"container":"ChartWithIndicators_container__ofbnk","chartMain":"ChartWithIndicators_chartMain__VHAGa"};